import { render, staticRenderFns } from "./InfoReport.vue?vue&type=template&id=c21c40b2&scoped=true&"
import script from "./InfoReport.vue?vue&type=script&lang=js&"
export * from "./InfoReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21c40b2",
  null
  
)

export default component.exports